
import { Dialog } from "@/components/ui/dialog";
import AuthModalContent from "./auth/AuthModalContent";

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  defaultTab?: 'signin' | 'signup';
  onSuccess?: () => void;
  onError?: (message: string) => void;
}

export default function AuthModal({ isOpen, onClose, defaultTab = 'signin', onSuccess, onError }: AuthModalProps) {
  // Don't render the modal if it's not supposed to be open
  if (!isOpen) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <AuthModalContent 
        onClose={onClose} 
        defaultTab={defaultTab} 
        onSuccess={onSuccess}
        onError={onError}
      />
    </Dialog>
  );
}
